import '@styles/views/introduce.less';
import AppBannerqlsj from '@components/app/appBannerqlsj';
//import AppAdvantage from '@components/app/appAdvantage';
import AppBridgeMaster from '@views/appBridgeMaster2023';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
//import AppBimWindows from '@components/app/appBimWindows';
import AppFooter from '@components/app/appFooter';

const Introduce = () => {
  return (
    <div className={'introduce-page'}>
      <AppBannerqlsj />
      <AppBridgeMaster />
      {/* <AppBimWindows /> */}
      {/* <AppAdvantage showDesc  style={{ marginTop: '30px' }}/> */}
      {/* <AppDisplayDesc /> */}
      <AppFooter />
    </div>
  );
};

export default Introduce;
